import React from 'react';
import compose from 'lodash/fp/compose';
import { withMetrics } from '@catalogo/core-metrics';

const filters = {
  likes: 'mais-uteis',
  descending: 'mais-recentes',
  ascending: 'mais-antigas',
};
const sorts = {
  'mais antigas': 'ascending',
  'mais recentes': 'descending',
  'mais uteis': 'likes',
};

export const withFilter = Component => ({ fetchMore, offset, limit, total, dispatchMetrics }) => {
  const onChange = e => {
    e.target.value &&
      dispatchMetrics('event:track', {
        category: 'qna-pdp',
        action: 'qna-ordenacao',
        label: filters[e.target.value],
      });

    fetchMore({
      limit: offset + limit >= total ? total : offset + limit,
      offset: 0,
      sort: e.target.value,
      hasChangedOrder: true,
      loadingTarget: 'all',
    });
  };
  const onChangeNew = e => {
    e.target.id &&
      dispatchMetrics('event:track', {
        category: 'qna-pdp',
        action: 'qna-ordenacao',
        label: e.target.id.replace(' ', '-'),
      });

    fetchMore({
      limit: offset + limit >= total ? total : offset + limit,
      offset: 0,
      sort: sorts[e.target.id],
      hasChangedOrder: true,
      loadingTarget: 'all',
    });
  };

  return <Component onChange={onChange} onChangeNew={onChangeNew} />;
};

export default compose(withMetrics, withFilter);
